import Vue from 'vue';
import Vuex from 'vuex';
import validation from './modules/validation';
import caseSelect from './modules/caseSelect';
import tutorials from './modules/tutorials';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    validation,
    caseSelect,
    tutorials,
  },
  strict: debug,
  plugins: [],
});
